import { gql } from '@apollo/client';

const PartnerLocationInfoPublic = gql`
  fragment PartnerLocationInfoPublic on PartnerLocation {
    id
    name
    email
    phone
    website
    imageUrl
    address {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
  }
`;

export default PartnerLocationInfoPublic;
